export const getNameInitials = (name = '') => {
  const nameInitials = name.split(' ').reduce((a, item) => a + item.charAt(0), '')

  return nameInitials.toUpperCase().substring(0, 2)
}

export const extractStringsFromObject = (routes): String[] => {
  const output: string[] = []

  const extract = object => {
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key) && typeof object[key] !== 'object') {
        output.push(object[key])
      } else {
        extract(object[key])
      }
    }
  }

  extract(routes)

  return output
}
